import React from "react";
import { Divider } from "@mui/material";
import PopularDestinationCard from "./PopularDestinationCard";
import { primary } from "../../AppConfig";
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import CardList2 from "../Shimmer/card2";
import { useNavigate } from "react-router-dom";

function PopularDestination({stateData, language}) {
  const navigate = useNavigate();

  console.log('PopularDestination stateData:', stateData);

  const handelExploreMore = () => {
    if (language === "ar") {
      navigate(`/ar/all-states`); 
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    } else {
      navigate(`/en/all-states`); 
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    }
  };

  return ( 
    <>
      <div>
        {language === "ar" ? (
          <div className="flex lg:flex-row-reverse flex-col justify-between lg:px-20 max-sm:px-5 lg:-mt-36 max-sm:-mt-5 gap-3">
            {/* Heading */}
            <div className="text-end">
              <p className="text-xl max-sm:text-[16px]">الى اين اذهب</p>
              <p className="lg:text-4xl max-sm:text-[20px] font-bold mt-1" style={{ color: primary }}>
                الوجهات الشعبية
              </p>
            </div>

            {/* Divider */}
            <div className="lg:w-[40%] max-sm:w-full flex justify-start border-b border-black" />

            {/* Button */}
            <div className="flex justify-end lg:mt-5 max-sm:mt-4 w-full lg:w-auto">
              <button
                onClick={handelExploreMore}
                className="border-2 border-black rounded-full text-sm max-sm:px-4 px-6 py-1 font-semibold hover:bg-[#9747FF] hover:border-white hover:text-white flex items-center gap-1"
              >
                اكتشف المزيد <ChevronRightIcon sx={{ fontSize: "18px", transform: "rotate(180deg)" }} />
              </button>
            </div>
          </div>
        ) : (
          <div className="flex lg:flex-row flex-col justify-between lg:px-20 max-sm:px-5 lg:-mt-36 max-sm:-mt-5 gap-3">
            {/* Heading */}
            <div className="text-start">
              <p className="text-[25px] max-sm:text-[16px] max-sm:font-light">Where To Go</p>
              <p className="lg:text-[40px] max-sm:text-[20px] font-bold mt-1" style={{ color: primary }}>
                Popular Destinations
              </p>
            </div>

            {/* Divider */}
            <div className="lg:w-[40%] max-sm:w-full border-b border-black" />

            {/* Button */}
            <div className="flex justify-start lg:mt-5 max-sm:mt-4 w-full lg:w-auto">
              <button
                onClick={handelExploreMore}
                className="border-2 border-black font-semibold rounded-full text-sm max-sm:px-4 px-7 py-1 hover:bg-[#5B27D5] hover:border-white hover:text-white flex items-center gap-1"
              >
                Explore More <ChevronRightIcon sx={{ fontSize: "18px" }} />
              </button>
            </div>
          </div>
        )}
      </div>

      {!stateData || stateData.length === 0 ? (
        <div>
          <div className="flex lg:px-20 max-sm:px-5 lg:gap-20 max-sm:gap-5 overscroll-x-conatin overflow-x-scroll mt-5">
            <CardList2 />
            <CardList2 />
            <CardList2 />
            <CardList2 />
            <CardList2 />
          </div>
        </div>
      ) : (
        <div
          className={`lg:w-[100%] max-sm:w-[100%] lg:px-20 max-sm:px-5 lg:gap-7 max-sm:gap-3 flex overscroll-x-contain overflow-x-scroll lg:mt-10 max-sm:mt-6 ${
            language === "ar" ? "flex-row-reverse max-sm:px-5" : ""
          }`}
        >
          {stateData.map((i, key) => (
            <PopularDestinationCard key={key} state={i} language={language} />
          ))}
        </div>
      )}
    </>
  );
}

export default PopularDestination;